import * as React from 'react';

type BoldTextSegment = {
  bold: boolean;
  text: string;
};

export function parseBoldMarkdownSegments(text: string): BoldTextSegment[] {
  const segments: BoldTextSegment[] = [];
  const boldPattern = /\*\*(.+?)\*\*/g;
  let lastProcessedIndex = 0;
  let boldMatch: RegExpExecArray | null;

  while ((boldMatch = boldPattern.exec(text)) !== null) {
    if (boldMatch.index > lastProcessedIndex) {
      segments.push({
        bold: false,
        text: text.slice(lastProcessedIndex, boldMatch.index),
      });
    }
    segments.push({ bold: true, text: boldMatch[1] });
    lastProcessedIndex = boldMatch.index + boldMatch[0].length;
  }

  if (lastProcessedIndex < text.length) {
    segments.push({ bold: false, text: text.slice(lastProcessedIndex) });
  }

  if (!segments.length && text) {
    segments.push({ bold: false, text });
  }

  return segments;
}

export const FormattedText: React.FC<{
  text: string;
  className?: string;
}> = ({ text, className }) => {
  const textSegments = React.useMemo(
    () => parseBoldMarkdownSegments(text),
    [text]
  );

  return (
    <span className={className}>
      {textSegments.map((segment, segmentIndex) =>
        segment.bold ? (
          <strong key={segmentIndex}>{segment.text}</strong>
        ) : (
          <React.Fragment key={segmentIndex}>{segment.text}</React.Fragment>
        )
      )}
    </span>
  );
};
